<template>
  <div class="empty-state">
    <div class="empty-state__content">
      <template v-if="!withoutIcon">
      <div
        v-if="customSvg"
        class="empty-state__svg"
        v-html="customSvg"
      ></div>
      <span
        v-else-if="!customIcon"
        class="material-icons icon-image-preview empty-state__icon"
        >search_off</span
      >
      <span
        v-else
        :class="iconClasses"
        v-html="customIcon"
      ></span>
      </template>
      <div class="empty-state__title">{{ title }}</div>
      <div class="empty-state__description">
        {{ description }}
      </div>
      <button
        v-if="!withoutButton"
        class="btn button reset-button btn-secondary"
        @click="handleButtonClick"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyStateNoResults',
  props: {
    customSvg: {
      type: String,
      default: null
    },
    customIcon: {
      type: String,
      default: null
    },
    customIconClasses: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: 'No results found'
    },
    description: {
      type: String,
      default: "We couldn't find any records that match your filters."
    },
    buttonText: {
      type: String,
      default: 'Reset filters'
    },
    withoutButton: {
      type: Boolean,
      default: false
    },
    withoutIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClasses () {
      return this.customIconClasses || 'material-symbols-outlined empty-state__icon'
    }
  },
  methods: {
    handleButtonClick () {
      if (this.buttonText === 'Reset filters') {
        this.$emit('reset-filters')
      } else {
        this.$emit('button-click')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.empty-state__icon {
  font-size: 58px;
  width: 58px;
  height: 58px;
  color: $fontColorBase;
  margin-bottom: 16px;
}

.empty-state__svg {
  margin-bottom: 16px;

  ::v-deep svg {
    width: 58px;
    height: 58px;
  }
}

.empty-state__title {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  color: $fontColorBase;
  margin-bottom: 4px;
}

.empty-state__description {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: $fontColorBase;
  margin-bottom: 16px;
}
</style>
